import { types, actions } from './requests'
export const CREATESCHEDULE_TYPES = {
    ...types('CREATESCHEDULE'),
}
export const CREATESCHEDULE_ACTIONS = {
    ...actions('CREATESCHEDULE'),
}